import { render, staticRenderFns } from "./AboutItem.vue?vue&type=template&id=02396345&scoped=true&"
import script from "./AboutItem.vue?vue&type=script&lang=js&"
export * from "./AboutItem.vue?vue&type=script&lang=js&"
import style0 from "./AboutItem.vue?vue&type=style&index=0&id=02396345&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02396345",
  null
  
)

export default component.exports